import PortfolioDetail1Container from "../../../../components/pages/portfolio/detail/PortfolioDetail1";

const PortfolioDetail1 = () => {
  return <PortfolioDetail1Container />;
};

export default PortfolioDetail1;
